/**************************************************
 * Nombre:       Seccion_Detalle
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Home_Cabana from "./Componentes/Home_Cabana";
import Home_Servicios from "./Componentes/Home_Servicios";
import Home_Contactos from "./Componentes/Home_Contactos";
import Home_Actividades from "./Componentes/Home_Actividades";
import {APARTADOS} from "../../Constantes";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";
import Detalle_Portada from "./Componentes/Detalle_Portada";
import Detalle_Especificaciones from "./Componentes/Detalle_Especificaciones";
import {useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {irArriba} from "../../Utilidades/irArriba";

const Seccion_Detalle = () => {
    const {sCell} = useResponsive()
    const parms = useParams()
    const [nombre, setNombre] = useState('')


    useEffect(() =>{

        irArriba()
        if (parms && parms.id) {
            setNombre(parms.id)
        }


    },[parms])
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            <Grid id={APARTADOS[0]} container size={{xs: 12, sm: 12, md: 12}}
                  sx={{justifyContent: 'flex-start', zIndex: 1}}>
                <Detalle_Portada item={nombre}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start',mt: 10}}>
                <Detalle_Especificaciones/>
            </Grid>

            <Grid id={APARTADOS[1]} container size={{xs: 12, sm: 12, md: 12}}
                  sx={{justifyContent: 'flex-start', mt: sCell ? 10 : 12, zIndex: 2}}>
                <Home_Cabana/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', zIndex: 1, mt: -10}}>
                <Home_Servicios/>
            </Grid>

            <Grid id={APARTADOS[3]} container size={{xs: 12, sm: 12, md: 12}}
                  sx={{justifyContent: 'flex-start', mt: sCell ? 10 : 16}}>
                <Home_Contactos/>
            </Grid>

            <Grid id={APARTADOS[2]} container size={{xs: 12, sm: 12, md: 12}}
                  sx={{justifyContent: 'flex-start', mt: sCell ? 8 : 12}}>
                <Home_Actividades/>
            </Grid>

        </Grid>
    )

}
export default Seccion_Detalle